/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

const AccessWrapper = ({ isAccessed, children }) => isAccessed ? children : null

export default AccessWrapper
